import { dateFromJSON } from 'Shared/JSON';
import {
  ActionStatusJSON, ActionJSON, ActionDetailsJSON, DailyStatusJSON,
  FrequencyJSON
} from 'Api/JSON/CarePlans';
import {
  ActionStatus, Action, ActionDetails, ActionType, DailyStatus, Frequency,
  isDataCapture
} from 'CarePlans/Data';

import { expandedSpecTypeFromJSON } from 'Specs/JSON';

export function dailyStatusFromJSON(json: DailyStatusJSON): DailyStatus {
  return {
    date: dateFromJSON(json.date),
    statuses: actionStatusesFromJSON(json.statuses)
  };
}

// Drops statuses with data captures this client build does not recognize (it has no way
// to collect their input); the server filters these too, this is a second layer
export function actionStatusesFromJSON(
  jsons: ActionStatusJSON[]
): ActionStatus[] {
  return jsons.filter(recognizedCapture).map(actionStatusFromJSON);
}

export function actionStatusFromJSON(json: ActionStatusJSON): ActionStatus {
  return {
    complete: json.complete,
    text: json.text,
    action: actionFromJSON(json.action)
  };
}

function recognizedCapture(json: ActionStatusJSON): boolean {
  const details = json.action.details;
  return details.type !== 'Task' ||
    details.capture == null ||
    isDataCapture(details.capture);
}

function actionFromJSON(json: ActionJSON): Action {
  return {
    id: json.id,
    details: actionDetailsFromJSON(json.details),
    frequency: frequencyFromJSON(json.frequency)
  };
}

function actionDetailsFromJSON(json: ActionDetailsJSON): ActionDetails {
  switch(json.type) {
    case 'Task':
      return {
        type: ActionType.TASK,
        task: json.task,
        capture:
          json.capture != null && isDataCapture(json.capture) ?
          json.capture : undefined
      };
    case 'Measurement':
      return {
        type: ActionType.MEASUREMENT,
        specType: expandedSpecTypeFromJSON(json.spec_type)
      };
  }
}

function frequencyFromJSON(json: FrequencyJSON): Frequency {
  switch(json) {
    case 'daily':
      return Frequency.DAILY;
    case 'daily_am':
      return Frequency.DAILY_AM;
    case 'daily_pm':
      return Frequency.DAILY_PM;
    case 'weekly':
      return Frequency.WEEKLY;
    case 'monthly':
      return Frequency.MONTHLY;
  }
}
